import { update } from "lodash";
import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { api } from "../../../utils/Api";
import ModalDeletedPrice from "./ModalDeletedPrice";
import { useParams } from "react-router-dom";
import DeleteAlert from "../../../components/Alert/DeleteAlert";
import ModalReworkSalary from "./ModalReworkSalary";

const price = {
  rework_salary: "",
  gst_percent: "",
  hsn: "",
  amount: "",
  gst_amount: "",
  total_amount: "",
};

export default function ModalRework(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [is_open, SetIsOpen] = useState(false);
  const [active, SetActive] = useState(true);
  const [id_value, SetIdValue] = useState(useParams());

  const [org_active_data, SetOrgActiveData] = useState([]);
  const [active_data, SetActiveData] = useState([]);
  const [deleted_data, SetDeletedData] = useState([]);
  const [update_value, SetUpdateValue] = useState(false);
  const [update_price, SetUpdatePrice] = useState(price);
  const [deleted_price_modal, SetDeletedPriceModal] = useState({
    is_open: false,
    type: "price",
    value: [],
  });
  const [update_init_data, SetUpdateInitData] = useState({});
  const [delete_modal, SetDeleteModal] = useState({
    record: {},
    index: "",
  });
  const [rework_salary_modal, SetReworkSalaryModal] = useState({
    is_open: false,
    data: "",
  });

  useEffect(() => {
    console.log("Rework close data :", close_data);
  }, []);

  useEffect(() => {
    if (props.isOpen) {
      console.log("Rework On Open :", props);
      SetIsOpen(props.isOpen);
      SetOrgActiveData(props.data.active_data);
      SetActiveData(props.data.active_data);
      SetDeletedData(props.data.deleted_data);
    }
  }, [props.isOpen]);

  const Switch = ({ isOn, handleToggle, onColor }) => {
    return (
      <>
        <input
          checked={isOn}
          onChange={handleToggle}
          className="react-switch-checkbox"
          id={`react-switch-new`}
          type="checkbox"
        />
        <label
          style={{ background: isOn && onColor }}
          className="react-switch-label"
          htmlFor={`react-switch-new`}
        >
          <span className={`react-switch-button`} />
        </label>
      </>
    );
  };

  async function delete_rework(rework: any, index: number) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
      },
      post: {
        service_id: props.data.service_id,
        rework_id: rework.id,
      },
    };
    let data = await api("/outlet/delete_rework", pass_data);
    console.log("delete_rework response :", data);
    if (data.status_code == 200) {
      // SetActiveData((prevValue) => {
      //   prevValue.splice(index, 1);
      //   return [...prevValue];
      // });
      // SetDeletedData((prevValue) => {
      //   prevValue.push(note);
      //   return [...prevValue];
      // });
      SetIsOpen(false);
      let item = close_data;
      item.action = "reload";
      item.service_data = data.response.order_services;
      SetCloseData(item);
      SetIsOpen(false);
      SetUpdateValue(false);
      props.close(close_data);
    }
  }

  async function update(rework: any, r_index: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
      },
      post: {
        rework_id: rework.id,
        gst: update_price.gst_percent,
        hsn: update_price.hsn,
        amount: update_price.amount,
        rework_salary: update_price.rework_salary,
      },
    };
    // let data = await api("/outlet/update_rework_price", pass_data);
    // console.log("Update price:", data);
    // SetActiveData([update_price])
    let update_prices = active_data;
    console.log("Update price1:", update_prices);
    update_prices[r_index].price[0].amount = update_price.amount;
    update_prices[r_index].price[0].gst_amount = update_price.gst_amount;
    update_prices[r_index].price[0].gst_precent = update_price.gst_percent;
    update_prices[r_index].price[0].hsn = update_price.hsn;
    update_prices[r_index].price[0].rework_salary = update_price.rework_salary;
    update_prices[r_index].price[0].total_amount = update_price.total_amount;
    console.log("Update price2:", update_prices);
    SetActiveData(update_prices);
    SetUpdateValue(false);
  }

  function DeletePriceModalClose(data: any) {
    console.log("Delete price modal close:", data);
    SetDeletedPriceModal({ is_open: false, value: [], type: "" });
  }

  async function get_update_init(r_id) {
    console.log("Get update init");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
        rework_id: r_id,
      },
    };
    console.log("pass_data :", pass_data);
    let data = await api("/outlet/update_rework_init", pass_data);
    console.log("update_rework_init:", data);
    if (data.response.hasOwnProperty("data")) {
      if (Object.keys(data.response.data).length > 0) {
        let init_data = data.response.data;
        let gst_amount_value =
          (init_data.settings_gst_percent / 100) * init_data.amount;
        init_data.gst_amount = gst_amount_value;
        init_data.total_amount =
          parseFloat(init_data.amount) + parseFloat(gst_amount_value);
        SetUpdateInitData(init_data);
      } else {
        SetUpdateInitData([]);
      }
    }
  }

  async function update_rework(r_id: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
        rework_id: r_id,
      },
      post: {
        data: update_init_data,
      },
    };
    console.log("pass_data :", pass_data);
    let data = await api("/outlet/update_rework", pass_data);
    console.log("update_rework response:", data);
    if (data.response.hasOwnProperty("order_services")) {
      let item = close_data;
      item.action = "save";
      item.service_data = data.response.order_services;
      SetCloseData(item);
      SetIsOpen(false);
      SetUpdateValue(false);
      props.close(close_data);
    }
  }

  async function finish_rework(r_id: any) {
    console.log("Finish rework");
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: id_value.order_id,
      },
      post: {
        rework_id: r_id,
      },
    };
    let res = await api("/outlet/finish_rework", pass_data);
    console.log("finish_rework res :", res);
    if (res.response.status) {
      let item = close_data;
      item.action = "reload";
      SetCloseData(item);
      SetIsOpen(false);
      SetUpdateValue(false);

      props.close(close_data);
    }
  }

  return (
    <div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={is_open}
        // hideHeader={true}
        // closeIcon={
        //   <i className="fas fa-pen-nib cursor" style={{ color: "gray" }}></i>
        // }
        title="Rework"
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          let item = close_data;
          item.action = "close";
          SetCloseData(item);
          SetIsOpen(false);
          SetActive(true);
          SetUpdateValue(false);
          console.log("close");
          props.close(close_data);
        }}
        from="right"
        width="500px"
      >
        <div className="row">
          <div className="sticky pt-2 p-0">
            <div className="row border-bottom w-100">
              <div className="col-6 text-center">
                <p
                  className={
                    active == true
                      ? "cursor active_filter mb-0"
                      : "pt-1 mb-0 cursor"
                  }
                  onClick={() => {
                    SetActive(true);
                    console.log("Active");
                  }}
                >
                  Active Rework ({active_data.length})
                </p>
              </div>
              <div className="col-6 text-center">
                <p
                  className={
                    active == false
                      ? "cursor active_filter mb-0"
                      : "pt-1 mb-0 cursor"
                  }
                  onClick={() => {
                    SetActive(false);
                    console.log("Deleted");
                  }}
                >
                  Deleted Rework ({deleted_data.length})
                </p>
              </div>
            </div>
          </div>

          <div className=" p-0">
            {active == true ? (
              <div>
                {active_data.map((rework, r_index) => (
                  <div className="card p-2 x-scroll" key={r_index}>
                    <div className=" text-end">
                      {update_value == false ? (
                        props.order_status_id != "2" ? (
                          <div className="d-flex justify-content-end align-items-center p-2 pt-3">
                            {/* Finish rework */}
                            {rework.task_finished == true &&
                            rework.finished == false ? (
                              <button
                                className="btn btn-light-outline"
                                onClick={() => {
                                  finish_rework(rework.id);
                                }}
                              >
                                Finish Rework
                              </button>
                            ) : null}
                            {/* Edit Rework */}
                            <div
                              className="px-4"
                              onClick={() => {
                                SetUpdateValue(true);
                                get_update_init(rework.id);
                              }}
                            >
                              <i
                                className="fas fa-pen-nib cursor"
                                style={{ color: "gray" }}
                              ></i>
                            </div>
                            {/* Delete rework */}
                            <div
                              className="px-4"
                              data-bs-toggle="modal"
                              data-bs-target="#ReworkDeleteAlertModal"
                              onClick={() => {
                                // delete_rework(rework, r_index);
                                console.log("Delete rework");
                                SetDeleteModal((prevValue: any) => {
                                  prevValue.record = rework;
                                  prevValue.index = r_index;
                                  return { ...prevValue };
                                });
                              }}
                            >
                              <i
                                className="fas fa-trash-alt cursor"
                                style={{ color: "gray" }}
                              ></i>
                            </div>
                          </div>
                        ) : null
                      ) : (
                        <div className="d-flex justify-content-end p-2 py-3">
                          {/* Update */}
                          <div
                            className="text-center px-4 cursor"
                            onClick={() => {
                              update_rework(rework.id);
                            }}
                          >
                            <img
                              src={require("../../../assets/icon/svg/check-1.svg")}
                              className="action-img cursor"
                            />
                          </div>
                          {/* Cancel */}
                          <div
                            className="px-4 text-center cursor"
                            onClick={() => {
                              SetUpdateValue(false);
                            }}
                          >
                            <img
                              src={require("../../../assets/icon/svg/x1.svg")}
                              className="action-img cursor"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <label className="form-label">Message : </label>
                      <textarea
                        className="form-control"
                        disabled={true}
                        value={rework.message}
                      />
                    </div>

                    {update_value == true ? (
                      <div className="p-2">
                        <div className="row align-items-center">
                          <div className="col-4">
                            <h6>Price</h6>
                          </div>
                          {/* Free */}
                          <div className="d-flex pt-md-2 pb-2 align-items-center">
                            <input
                              type="checkbox"
                              className="me-3 form-check-input"
                              checked={update_init_data.free}
                              onChange={(e) => {
                                if (update_init_data.editable) {
                                  SetUpdateInitData((prevValue) => {
                                    prevValue.free = !prevValue.free;
                                    return { ...prevValue };
                                  });
                                }
                              }}
                            />
                            <label className="form-label mb-0">Free</label>
                          </div>
                        </div>
                        {!update_init_data.free ? (
                          <div className="row pt-1">
                            <div className="col-6">
                              {/* Gst % */}
                              <div className="row pt-md-2 pb-2 align-items-center">
                                <label className="form-label col-md-7 col-12">
                                  GST :
                                </label>
                                <div className="col-md-5">
                                  <Switch
                                    isOn={update_init_data.gst}
                                    onColor="#06D6A0"
                                    handleToggle={(e) => {
                                      SetUpdateInitData((prevValue) => {
                                        prevValue.gst = !prevValue.gst;
                                        let percent =
                                          prevValue.settings_gst_percent;
                                        let gst_amount_value =
                                          (percent / 100) * prevValue.amount;
                                        prevValue.gst_amount = gst_amount_value;

                                        if (prevValue.gst) {
                                          prevValue.total_amount =
                                            parseFloat(gst_amount_value, 2) +
                                            parseFloat(prevValue.amount, 2);
                                        } else {
                                          prevValue.total_amount =
                                            prevValue.amount;
                                        }
                                        return { ...prevValue };
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-6 text-end">
                              {/* Amount */}
                              <div className="row pt-md-2 pb-2 align-items-center">
                                <label className="form-label col-md-7 col-12">
                                  Amount :
                                </label>
                                <div className="col-md-5">
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={
                                      update_init_data.amount == null
                                        ? ""
                                        : update_init_data.amount
                                    }
                                    onChange={(e) => {
                                      console.log("amount :", e.target.value);
                                      if (update_init_data.editable) {
                                        SetUpdateInitData((prevValue) => {
                                          let percent =
                                            prevValue.settings_gst_percent;
                                          let entered_amount = e.target.value;

                                          let gst_amount_value =
                                            (percent / 100) * entered_amount;
                                          prevValue.amount = entered_amount;
                                          prevValue.gst_amount =
                                            gst_amount_value;

                                          if (prevValue.gst) {
                                            prevValue.total_amount =
                                              parseFloat(gst_amount_value, 2) +
                                              parseFloat(entered_amount, 2);
                                          } else {
                                            prevValue.total_amount =
                                              entered_amount;
                                          }
                                          return { ...prevValue };
                                        });
                                      }
                                    }}
                                  />
                                </div>
                              </div>
                              {/* Gst Amount */}
                              {update_init_data.gst ? (
                                <div className="row pt-md-2 pb-2 align-items-center">
                                  <label className="form-label col-md-7 col-12">
                                    GST Amount :
                                  </label>
                                  <div className="col-md-5">
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={
                                        update_init_data.gst_amount == null
                                          ? ""
                                          : update_init_data.gst_amount
                                      }
                                      disabled={true}
                                      onChange={(e) => {
                                        console.log(
                                          "GST Amount :",
                                          e.target.value
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              ) : null}

                              {/* Total Amount */}
                              <div className="row pt-md-2 pb-2 align-items-center">
                                <label className="form-label col-md-7 col-12">
                                  Total Amount :
                                </label>
                                <div className="col-md-5">
                                  <input
                                    type="number"
                                    className="form-control"
                                    disabled={true}
                                    value={
                                      update_init_data.total_amount == null
                                        ? ""
                                        : update_init_data.total_amount
                                    }
                                    onChange={(e) => {
                                      console.log(
                                        "Total Amount :",
                                        e.target.value
                                      );
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <div className="mt-2">
                          <span>Task</span>
                          {update_init_data.tasks &&
                            update_init_data.tasks.map(
                              (task_ele, task_index) => (
                                <div key={task_index}>
                                  <div className="d-flex pt-md-2 pb-2 align-items-center">
                                    <input
                                      type="checkbox"
                                      className="form-check me-3"
                                      checked={task_ele.checked}
                                      disabled={!task_ele.editable}
                                      onChange={(e) => {
                                        if (
                                          update_init_data.tasks[task_index]
                                            .editable
                                        ) {
                                          SetUpdateInitData((prevValue) => {
                                            prevValue.tasks[
                                              task_index
                                            ].checked =
                                              !prevValue.tasks[task_index]
                                                .checked;
                                            return { ...prevValue };
                                          });
                                        }
                                      }}
                                    />
                                    <label className="form-label col-md-7 col-12 mb-0">
                                      {task_ele.name}
                                    </label>
                                  </div>

                                  {task_ele.checked ? (
                                    <div className="row pt-md-2 pb-2 align-items-center">
                                      <label className="form-label col-md-7 col-12">
                                        Salary :
                                      </label>
                                      <div className="col-md-5">
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={task_ele.salary}
                                          // disabled={!task_ele.editable}
                                          onChange={(e) => {
                                            // if (
                                            //   update_init_data.tasks[task_index]
                                            //     .editable
                                            // ) {
                                            SetUpdateInitData((prevValue) => {
                                              prevValue.tasks[
                                                task_index
                                              ].salary = e.target.value;
                                              return { ...prevValue };
                                            });
                                            // }
                                          }}
                                        />
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    ) : (
                      <div>
                        {/* Price */}
                        {rework.price.map((price_ele, price_index) => (
                          <div className="border-bottom p-2" key={price_index}>
                            <div className="row py-2">
                              <div className="col-6">
                                <h6>Price {price_ele.free ? ": Free" : ""}</h6>
                              </div>
                              {rework.hasOwnProperty("deleted_price") ? (
                                <div className="col-6 text-end">
                                  <p
                                    className="cursor text-primary"
                                    onClick={() => {
                                      SetDeletedPriceModal({
                                        is_open: true,
                                        type: "price",
                                        value: rework.deleted_price,
                                      });
                                      console.log("View Deleted Price");
                                    }}
                                  >
                                    View Deleted Prices
                                  </p>
                                </div>
                              ) : null}
                            </div>
                            {!price_ele.free ? (
                              <div className="row pt-1">
                                <div className="col-6">
                                  {/* <p>
                                    <b className="text-dark">GST % :</b>
                                    {price_ele.gst_percent}
                                  </p>

                                  <p>
                                    <b className="text-dark">HSN :</b>
                                    {price_ele.hsn}
                                  </p> */}
                                </div>
                                <div className="col-6 text-end">
                                  <p>
                                    <b className="text-dark">Amount :</b>
                                    {price_ele.amount}
                                  </p>
                                  <p>
                                    <b className="text-dark">GST Amount :</b>
                                    {price_ele.gst_amount}
                                  </p>
                                  <p>
                                    <b className="text-dark">Total Amount :</b>
                                    {price_ele.total_amount}
                                  </p>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ))}
                        {/* Task */}
                        <div>
                          <div className="row p-2">
                            <div className="col-6">
                              <h6>Task </h6>
                            </div>
                            {rework.hasOwnProperty("deleted_task") ? (
                              <div className="col-6 text-end">
                                <p
                                  className="cursor text-primary"
                                  onClick={() => {
                                    SetDeletedPriceModal({
                                      is_open: true,
                                      type: "task",
                                      value: rework.deleted_task,
                                    });
                                    console.log("View Deleted Task");
                                  }}
                                >
                                  View Deleted Task
                                </p>
                              </div>
                            ) : null}
                          </div>
                          {rework.task.map((task_ele, task_index) => (
                            <div className="row d-flex px-2" key={task_index}>
                              <span>{task_ele.task_name}</span>
                              <div className="col-12">
                                <p>Rework Salary : {task_ele.rework_salary}</p>
                                <p>Status : {task_ele.status}</p>
                              </div>
                              <button
                                className="btn btn-light-outline"
                                onClick={() => {
                                  console.log("editor pay");
                                  SetReworkSalaryModal((prevValue: any) => {
                                    prevValue.is_open = true;
                                    prevValue.data = task_ele;
                                    return { ...prevValue };
                                  });
                                }}
                              >
                                Editor Pay
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div>
                {deleted_data.map((d_data, dn_index) => (
                  <div className="pt-3 p-2 d-flex" key={dn_index}>
                    <h6>Message : </h6>
                    <p className="mb-0 ps-2">{d_data.message}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </SlidingPane>

      <ModalDeletedPrice
        data={deleted_price_modal}
        close={(data) => {
          DeletePriceModalClose(data);
        }}
      />

      <ModalReworkSalary
        open={rework_salary_modal.is_open}
        data={rework_salary_modal.data}
        close={(data: any) => {
          SetReworkSalaryModal((prevValue: any) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });
        }}
      />

      {/* Delete Modal */}
      <div
        className="modal fade"
        id="ReworkDeleteAlertModal"
        tabIndex={-1}
        aria-labelledby="ModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="  modal-title" id="ModalLabel">
                Delete Rework
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              Are you sure want to delete rework ?
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  console.log("Delete Confirm");
                  delete_rework(delete_modal.record, delete_modal.index);
                }}
              >
                Delete
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
